"use client";

import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1] as const;
const DRAW_RAIL = {
  initial: { scaleY: 0 },
  animate: { scaleY: 1 },
  transition: { duration: 2.4, ease: [...EASE], delay: 0.2 },
} as const;
const REVEAL_HATCH = {
  initial: { opacity: 0, y: -24 },
  animate: { opacity: 0.28, y: 0 },
  transition: { duration: 1.4, ease: [...EASE], delay: 1 },
} as const;
const HATCH =
  "absolute top-[57.75rem] h-[70rem] bg-[repeating-linear-gradient(-45deg,#fff_0_0.6px,transparent_0.6px_1.25rem)] [mask-image:linear-gradient(#000,transparent)]";

// Side rails and hatch panels framing the changelog (desktop only).
export default function ChangelogDecor() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-y-0 left-1/2 hidden w-[240rem] max-w-full -translate-x-1/2 lg:block">
      <motion.div
        {...DRAW_RAIL}
        className="absolute inset-y-0 left-[23.875rem] w-px origin-top bg-white/[0.16]"
      />
      <motion.div
        {...DRAW_RAIL}
        className="absolute inset-y-0 left-[215.875rem] w-px origin-top bg-white/[0.16]"
      />
      <motion.div
        {...REVEAL_HATCH}
        className={`${HATCH} left-[0.125rem] w-[23.75rem]`}
      />
      <motion.div
        {...REVEAL_HATCH}
        className={`${HATCH} left-[215.875rem] w-[24.125rem]`}
      />
    </div>
  );
}
